/*

		Total	 Buy	 Sold	  Per   Duration
Mon 	11		9		  2		  3-8		0-90
Tue		17		13	  5		  6-11	taking too long time
Wed		13		10	  3		  6-18	0-90	
Thu		13		6		  7		  5-12	taking long time
Fri		15		10	  5		  6-12	0-90

*/

import React, { useState, useEffect } from "react";
import StockAction from "../component/stockAction";
import PageLoader from "../component/loader";
import {
  addPortfolioList,
  getDeliveryPercentList,
  getGoogleSheet,
  getMyPrediction,
  getSymbolList,
  myPortfolioList,
} from "../action/api-services";
import { Modal } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeliveryGraph from "../component/deliveryGraph";
import { toast } from "react-toastify";
import {
  convertDaysApprox,
  dematAmountList,
  methodList,
  diffDays,
  AIPromptForStock1,
} from "../utils/constants";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import StockStrength from "../component/stockStrength";
import { degAngle } from "../utils/utilsFunctions";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";

const PortfolioListPage = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [portfolioData, setPortfolioData] = useState([]);  
  const [myPortfolioListData, setMyPortfolioListData] = useState([]);
  const [mySoldListData, setMySoldListData] = useState([]);
  const [getYearlyStatus, setYearlyStatus] = useState({});
  const [symbolData, setSymbolData] = useState([]);
  const [predictionData, setPredictionData] = useState([]);
  const [todayData, setTodayData] = useState([]);
  const [todayDate, setTodayDate] = useState();
  const [show, setShow] = useState(false);
  const [getDateLabel, setDateLabel] = useState("Sold Date");
  const [paramsMeta, setParamsMeta] = useState([]);
  const [slPriceU, setSLPriceU] = useState(0);
  const [slPercent, setSLPercent] = useState(0);
  const [gttPriceU, setGttPriceU] = useState(0);
  const [gttPercent, setGttPercent] = useState(0);
  const [toastShown, setToastShown] = useState(false);
  const [getUnitPrice, setUnitPrice] = useState();
  const [series, setSeries] = useState('EQ');
  const [getTara, setTara] = useState("");

  const NSE_Past_date = useSelector((state) => state.pastDate.value);
  // const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
  const [startDate, setStartDate] = useState(new Date());
  const userToken = useSelector((state) => state.userToken.value);
  const navigate = useNavigate();


  useEffect(() => {
  if (!userToken) {
    navigate(`/`);
    return;
  }

  const current_date = moment(startDate).format("DDMMYY");
  setLoader(true);
  Promise.all([
    getSymbolList(series, '', userToken),
    getGoogleSheet("", userToken),
    getMyPrediction(current_date, userToken),
    myPortfolioList(userToken),
    getDeliveryPercentList('', 'portflio', '', '', series, '', userToken)
  ])
    .then(([symbolRes, sheetRes, predictionRes, portfolio, delivery]) => {
      setSymbolData(symbolRes?.data?.data || []);
      setTodayDate(sheetRes?.data?.data?.datetime || null);
      setTodayData(sheetRes?.data?.data?.json_data || []);
      setPredictionData(predictionRes?.data?.data || []);
      setPortfolioData(portfolio?.data?.data || []);
      dispatch(setDeliveryDataReducer(delivery.data.data));
    })
    .catch((err) => {
      console.log("Error", err);
    })
    .finally(() => setLoader(false));

}, [userToken]);


useEffect(() => {
  if (portfolioData) {
    let data = portfolioData;

    const inPortfolioData = data.filter(
      (obj) =>
        parseInt(obj.status) === 1 &&
        parseInt(obj.portfolio) === 1 &&
        parseFloat(obj.sold_price) === 0 &&
        (!obj.sold_date || obj.sold_date === "null")
    );

    const inSoldData = data.filter(
      (obj) =>
        parseInt(obj.status) === 1 &&
        parseInt(obj.portfolio) === 1 &&
        parseFloat(obj.sold_price) > 0 &&
        obj.sold_date &&
        obj.sold_date !== "null"
    );

    // ✅ Filter from 1 April 2026
    const startDate = new Date("2026-04-01");

    const filteredSoldData = inSoldData.filter(
      (obj) => new Date(obj.sold_date) >= startDate
    );

    // ✅ Group by month
    const soldByMonth = filteredSoldData.reduce((acc, obj) => {
      const date = new Date(obj.sold_date);
      const monthName = date.toLocaleString("default", { month: "long" });

      if (!acc[monthName]) acc[monthName] = [];
      acc[monthName].push(obj);
      return acc;
    }, {});

    // ✅ Sort inside each month
    Object.keys(soldByMonth).forEach((month) => {
      soldByMonth[month].sort(
        (a, b) => new Date(a.sold_date) - new Date(b.sold_date)
      );
    });

    setMyPortfolioListData(inPortfolioData);
    setMySoldListData(soldByMonth);
  }
}, [portfolioData]);

  const addPortfolioHandler = (e, item) => {
    e.preventDefault();
    setShow(true);
    const itemMeta = {
      id: item.id,
      symbol: item.symbol,
      buy_date: item.buy_date,
      buy_price: item.buy_price,
      sl_price: item.sl_price,
      gtt_price: item.gtt_price,
      gtt_SL: item.gtt_SL,
      gtt_Target: item.gtt_Target,
      unit_qty: item.unit_qty,
      method: item.method,
    };
    
    setParamsMeta(itemMeta);
    setSLPriceU(item.sl_price);
    setGttPriceU(item.gtt_price);

    setSLPercent(-Math.abs((((item.sl_price - item.buy_price) * 100)/ item.buy_price).toFixed(2)));
    setGttPercent((((item.gtt_price - item.buy_price) * 100)/ item.buy_price).toFixed(2));
    setUnitPrice(item.buy_price);

    setStartDate(moment().toDate());

    window.calculate(moment(startDate).toDate());
    let panchang = JSON.parse(localStorage.getItem("panchang"));
    setTara(panchang.Tara);
    
  };

  const postPortfolioData = (e) => {
    e.preventDefault();
    const form = e.target;
    const soldDate = form.elements.soldDate.value;
    const buyingprice = form.elements.buyingprice.value;
    const sl_price = form.elements.slPriceU.value;
    const gtt_price = form.elements.gttpriceU.value;
    const soldprice = form.elements.soldprice.value;
    const soldqty = form.elements.soldqty.value;
    const gttupdate = form.elements.forgttupdate.checked ? true : false;
    const forAllUpdate = form.elements.forAllUpdate.checked ? true : false;

    let params = {buy_tara : getTara};
    if (
      parseInt(soldqty) < parseInt(paramsMeta.unit_qty) &&
      forAllUpdate === true
    ) {
      toast.error(
        `Unit Qty should be equal and greater then  ${paramsMeta.unit_qty}`
      );
      document.querySelector("#soldqty").value = paramsMeta.unit_qty;
      return false;
    }

    if (
      parseInt(soldqty) > parseInt(paramsMeta.unit_qty) &&
      forAllUpdate === false
    ) {
      toast.error(
        `Unit Qty should be not greater then  ${paramsMeta.unit_qty}`
      );
      document.querySelector("#soldqty").value = paramsMeta.unit_qty;
      return false;
    }

    if (gttupdate === true) {
      if (gtt_price === "" || sl_price === "") {
        toast.error("Please fill the required field");
        return false;
      } else {
        params = {
          source: "gtt_update",
          newEntry: false,
          symbol_Id: paramsMeta.id,
          gtt_price: gtt_price,
          sl_price: sl_price,
          gtt_SL: form.elements.forgttactiveSL.checked ? true : false,
          gtt_Target: form.elements.forgttactiveTarget.checked ? true : false
        };
      }
    } else if (forAllUpdate === true) {
      params = {
        source: "all_update",
        newEntry: false,
        symbol_Id: paramsMeta.id,
        buy_date: moment(soldDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
        method: paramsMeta.method,
        buy_price: buyingprice,
        gtt_price: gtt_price,
        sl_price: sl_price,
        unit_qty: soldqty,
        buy_tara: getTara
      };
    } else {
      if (
        soldDate === "" ||
        soldprice === "" ||
        soldqty === ""
      ) {
        toast.error("Please fill the required field");
        return false;
      } else {
        params = {
          source: "add_to_sold",
          newEntry: false,
          symbol_Id: paramsMeta.id,
          sold_date: moment(soldDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
          method: paramsMeta.method,
          gtt_price: gtt_price,
          sl_price: sl_price,
          sold_price: soldprice,
          unit_qty: soldqty,
          sold_tara: getTara
        };
      }
    }

    addPortfolioList(params, userToken)
      .then(function (response) {
        if (response.data.status === true) {
          setMyPortfolioListData(prev =>  prev.map(item =>   item.id === response.data.data.id ? response.data.data : item))

          const row = document.getElementById("item_id_" + paramsMeta.id);
          const unitPrice = document.getElementById("unitID_" + paramsMeta.id);
          const unitQTY = document.getElementById("qtyID_" + paramsMeta.id);
          const buyAmount = document.getElementById(
            "buyAmountID_" + paramsMeta.id
          );
          const gttAmount = document.getElementById("gttID_" + paramsMeta.id);

          const msg =
            gttupdate === true
              ? "Changed"
              : forAllUpdate === true
              ? "Updated"
              : "Sold";

          if (gttAmount && gttupdate === true) {
            gttAmount.innerText = Number(gtt_price).toFixed(2);
          }

          if (forAllUpdate === true) {
            unitPrice.innerText = Number(buyingprice).toFixed(2);
            unitQTY.innerText = soldqty;
            buyAmount.innerText = (Number(buyingprice) * soldqty).toFixed(2);
            gttAmount.innerText = Number(gtt_price).toFixed(2);
          }

          if (row && gttupdate === false && forAllUpdate === false) {
            row.remove();
          }

          toast.success(`${msg} Successfully`, {
            onClose: () => {
              // setShow(false);
            },
          });
          setShow(false);
          setDateLabel("Sold Date");
          setStartDate(new Date());
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(function (err) {
        console.error("Error:", err);
      });
  };

  const unitPriceUpdateHindler = (e) => {
    setUnitPrice(e.target.value);

    const percent = 3;
    const gtt = (
      Number(e.target.value) +
      (Number(e.target.value) * percent) / 100
    ).toFixed(2);

    // document.querySelector("#gttpercent").value = percent;
    // document.querySelector("#gttpriceU").value = gtt;
    // document.querySelector("#gttunitprice").value = gtt;
  };

  const gttUnitPriceChangeHandler = (e) => {
    const price = Number(e.target.value);

    if (price < Number(paramsMeta.buy_price)) {
      if (!toastShown) {
        // toast.error("Amount should be greater than unit price (" + paramsMeta.buy_price + ")");
        setToastShown(true);
      }
    } else {
      // Reset the flag if input becomes valid again
      setToastShown(false);
    }

    const gttprice = document.getElementById("gttpriceU");
    const gttunitprice = document.getElementById("gttunitprice");
    if (gttprice && gttunitprice) {
      gttprice.value = price;
      gttunitprice.value = price;
    }

    setGttPriceU(price);

    let percent = ((price - Number(getUnitPrice)) * 100) / Number(getUnitPrice);
    const element3 = document.getElementById("gttpercent");
    if (element3) {
      element3.value = percent >= 0 ? percent.toFixed(2) : 0;
    }
  };

  const slUnitPriceChangeHandler = (e) =>{
    const price = Number(e.target.value);

    if (price > Number(paramsMeta.buy_price)) {
      if (!toastShown) {
        // toast.error("Amount should be greater than unit price (" + paramsMeta.buy_price + ")");
        setToastShown(true);
      }
    } else {
      // Reset the flag if input becomes valid again
      setToastShown(false);
    }

    const slprice = document.getElementById("slPriceU");
    const slunitprice = document.getElementById("slunitprice");
    if (slprice && slunitprice) {
      slprice.value = price;
      slunitprice.value = price;
    }

    setSLPriceU(price);

    let percent = ((price - Number(getUnitPrice)) * 100) / Number(getUnitPrice);
    const element3 = document.getElementById("slpercent");
    if (element3) {
      // element3.value = percent >= 0 ? percent.toFixed(2) : 0;
        element3.value = percent.toFixed(2);
    }

    // setSLPercent(percent);

  }

  const gttpercentChangeHandler = (e) => {
    let percent = Number(e.target.value);
    const price = (
      Number(getUnitPrice) +
      (Number(getUnitPrice) * percent) / 100
    ).toFixed(2);

    const gttprice = document.getElementById("gttpriceU");
    const gttunitprice = document.getElementById("gttunitprice");
    if (gttprice && gttunitprice) {
      gttprice.value = price;
      gttunitprice.value = price;
    }
  };

  const slpercentChangeHandler = (e) => {
    let percent = Number(e.target.value);

   setSLPercent(-Math.abs(percent));

    const price = (
      Number(getUnitPrice) +
      (Number(getUnitPrice) * percent) / 100
    ).toFixed(2);

    const slprice = document.getElementById("slPriceU");
    const slunitprice = document.getElementById("slunitprice");
    if (slprice && slunitprice) {
      slprice.value = price;
      slunitprice.value = price;
    }
  };

  const gttUpdateHandler = (e) => {
    const isChecked =
        document.querySelector('#forgttactiveSL')?.checked ||
        document.querySelector('#forgttactiveTarget')?.checked ||
        document.querySelector('#forgttupdate')?.checked;

    document.querySelector("#forAllUpdate").checked = false;
    const submitBtn = document.getElementById("submitBtn");
    if (submitBtn) {
      // if (e.target.checked === true) {
      if(isChecked){
        submitBtn.textContent = "Update GTT";
        document.querySelector("#forgttupdate").checked = true;
      } else {
        submitBtn.textContent = "Sold";
        document.querySelector("#forgttupdate").checked = false;
      }
    }
  };

  const allUpdateHandler = (e) => {
    document.querySelector("#forgttupdate").checked = false;
    const submitBtn = document.getElementById("submitBtn");
    if (submitBtn) {
      if (e.target.checked === true) {
        submitBtn.textContent = "Update";
        setDateLabel("Buy Date");
        setStartDate(moment(paramsMeta.buy_date, "YYYY-MM-DD").toDate());
        window.calculate(moment(paramsMeta.buy_date, "YYYY-MM-DD").set({hour: 9, minute: 15, second: 0, millisecond: 0}).toDate());
        let panchang = JSON.parse(localStorage.getItem("panchang"));
        setTara(panchang.Tara);
      } else {
        submitBtn.textContent = "Sold";
        setDateLabel("Sold Date");
        setStartDate(new Date());
        window.calculate(moment().toDate());
        let panchang = JSON.parse(localStorage.getItem("panchang"));
         setTara(panchang.Tara);
      }
    }
  };

  useEffect(() => {
    let yearlyTotalBuy = 0;
    let yearlyTotalSold = 0;
    let yearlyTotalPL = 0;
    let yearlyTotalPLPer = 0;
    let yearlyTotalLoss = 0;
    let yearlyStatus = {};
    Object.entries(mySoldListData).map((obj, index) => {
      const monthName = obj[0];
      const monthData = obj[1];
      // console.log("iiiiii", monthData);
      monthData?.map((item, ind) => {
        // console.log("iiiiii", item);
        yearlyTotalBuy = yearlyTotalBuy + item.buy_price * item.unit_qty;
        yearlyTotalSold = yearlyTotalSold + item.sold_price * item.unit_qty;
        yearlyTotalPL = yearlyTotalSold - yearlyTotalBuy;
        yearlyTotalPLPer = (yearlyTotalPL * 100) / yearlyTotalBuy;
        yearlyTotalLoss =
          yearlyTotalLoss +
          (parseFloat(item.buy_price) > parseFloat(item.sold_price)
            ? parseFloat(item.buy_price) * parseInt(item.unit_qty) -
              parseFloat(item.sold_price) * parseInt(item.unit_qty)
            : 0);
      });

      yearlyStatus = {
        yearlyTotalBuy: yearlyTotalBuy.toFixed(2),
        yearlyTotalSold: yearlyTotalSold.toFixed(2),
        yearlyTotalPL: yearlyTotalPL.toFixed(2),
        yearlyTotalPLPer: yearlyTotalPLPer.toFixed(2),
        yearlyTotalLoss: yearlyTotalLoss.toFixed(2),
      };
    });
    // console.log(yearlyStatus);
    setYearlyStatus(yearlyStatus);
  }, [mySoldListData]);

  let totalInvest = 0;
  const totalInDematAmount = dematAmountList
    ?.reduce((total, d) => total + Number(d.Amount || 0), 0)
    .toFixed(2);


    const handleDateChange = (date) => {
        setStartDate(date);
        window.calculate(moment(date).toDate());
        let panchang = JSON.parse(localStorage.getItem("panchang"));
        setTara(panchang.Tara);
        // console.log("date", date, panchang.Tara)
    }

  return (
    <React.Fragment>
      <div className="pageContainer">
        {loader === true? (
          <PageLoader />
        ) : (
          <div className="pagewrap fullheight">
            <table className="increaseOI table-responsive">
              <thead>
                <tr>
                  <th style={{ textAlign: "left", width: "20px" }}>SN.</th>
                  <th style={{ width: "90px" }}>Buy Date</th>
                  <th style={{ textAlign: "left", width: "120px" }}>Symbol</th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "40px" }}></th>
                  <th style={{ width: "45px", textAlign: "left" }}>Strength</th>
                  <th style={{ width: "40px", textAlign: "left"}}>Series</th>
                  <th style={{ width: "35px", textAlign: "left"}}>Days</th>
                  <th style={{ width: "55px", textAlign: "left" }}>Indices</th>
                  <th style={{ width: "120px", textAlign: "left"}}>Sector</th>
                  <th style={{ width: "90px", textAlign: "left" }}>Method</th>
                  {/* <th style={{ width: "85px", textAlign: "left" }}>TR</th> */}
                  <th style={{ width: "55px" }}>LTP</th>
                  <th style={{ width: "60px" }}>Unit Price</th>
                  <th style={{ width: "60px" }}>Buy Units</th>
                  <th style={{ width: "75px" }}>Buying Price</th>
                  <th style={{ width: "50px" }}>SL</th>
                  <th style={{ width: "50px" }}>GTT</th>
                  <th style={{ width: "50px" }}>P/L</th>
                  <th style={{ width: "45px" }}>Deg° 5</th>
                  <th style={{ width: "45px" }}>14Days</th>
                  <th style={{ width: "50px" }}>SMA200</th>
                  <th style={{ width: "50px" }}>W Stgh</th>
                  {/* <th style={{ width: "50px" }}>W Del%</th> */}
                  <th style={{ width: "50px" }}>Del%</th>
                  {/* <th style={{ textAlign: "left" }}>EVENTS</th> */}
                  <th style={{ width: "75px", textAlign: "left" }}></th>
                  <th style={{ textAlign: "center", width: "60px" }}>Act</th>
                </tr>
              </thead>
              <tbody>
                {myPortfolioListData?.map((obj, index) => {
                  const symbolName = obj.symbol;
                  let details = symbolData.find(
                    (item, index) => item.symbol === symbolName
                  );
                  let prediction = predictionData?.find(
                    (item) => item.symbol === symbolName
                  );
                  let todayLTP = todayData?.find(
                    (item, index) => item.TICKER === symbolName
                  );


                  totalInvest = (
                    Number(totalInvest) + Number(obj.buy_price * obj.unit_qty)
                  ).toFixed(2);

                  return (
                    <tr
                      className={`tr_${details?.id}`}
                      key={`item_id_${obj.id}`}
                      id={`item_id_${obj.id}`}
                    >
                      <td>{index + 1}</td>
                      <td style={{fontSize: '0.675rem'}} title={obj.buy_tara}>{moment(obj.buy_date).format("ddd | DD/MM/YY")}</td>
                      <td style={{ textAlign: "left" }} className="symbolName">
                        {symbolName}{" "}
                        {details?.hotStar === "1" ? (
                          <span className="hotStar"></span>
                        ) : null}

                        <span className="gttaction">
                          {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                          {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                        </span>
                      </td>
                      <td>
                        <StockAction
                          symbol={symbolName}
                          delivery={false}
                          currentPrice={todayLTP?.LTP}
                          deliveryPer={prediction?.delivery_per}
                          hotStar={details?.hotStar}
                          myFev={details?.myFev}
                          eventName="Delivery"
                          rowId={`item_id_${obj.id}`}
                        />
                      </td>
                      <td>
                        <DeliveryGraph
                          symbol={symbolName}
                          todayLTP={todayLTP}
                          date={moment(startDate).format("YYYY-MM-DD")}
                        />
                      </td>
                      <StockStrength
                        id={`pl_${index}`}
                        selectedDate={moment(startDate).format("YYYY-MM-DD")}
                        symbol={symbolName}
                        todayLTP={todayLTP}
                        details={details}
                        predictions={prediction}
                      />
                      <td style={{ textAlign: "left" }}>{details?.series}</td>
                      <td
                        title={convertDaysApprox(
                          diffDays(obj.buy_date, new Date())
                        )}
                      >
                        {diffDays(obj.buy_date, new Date())}
                      </td>
                      <td className="indices" style={{ textAlign: "left" }}>
                        {(() => {
                          const label = details?.nifty50
                            ? "50"
                            : details?.nifty100
                            ? "100"
                            : details?.nifty200
                            ? "200"
                            : details?.nifty500
                            ? "500"
                            : details?.totalMarket
                            ? "TM"
                            : "";
                          const excludedSeries = ["ETF", "BOND", "MF"];
                          const showFev =
                            details?.myFev &&
                            !excludedSeries.includes(details?.series);
                          return (
                            label + (showFev ? `${label ? ", " : ""}Fev` : "")
                          );
                        })()}
                      </td>
                      <td style={{ textAlign: "left",lineHeight:1.15, textWrap:'wrap' }}>{details?.sector}</td>
                      <td style={{ textAlign: "left" }}>{obj.method}</td>
                      {/* <td
                        style={{
                          textAlign: "right",
                          color:
                            parseFloat(prediction?.datr) >
                            parseFloat(prediction?.adtr) >=
                            1
                              ? "#1c8b16"
                              : "",
                        }}
                        title={
                          parseFloat(prediction?.datr) >
                          parseFloat(prediction?.adtr)
                            ? "DATR > ADTR"
                            : ""
                        }
                      >
                        {prediction?.datr} | {prediction?.adtr}
                      </td> */}
                      {/* If DATR > ADTR, volatility is increasing → Expect big price movements. */}
                      <td
                        title={
                          todayLTP?.DATETIME !== "#N/A" && todayLTP?.DATETIME
                            ? moment(todayLTP.DATETIME).format(
                                "DD/MM/YY HH:mm"
                              ) +
                              " - " +
                              todayLTP.OPEN
                            : null
                        }
                        style={{
                          color:
                            todayLTP?.LTP > obj.buy_price ? "#1c8b16" : "#f00",
                        }}
                      >
                        {todayLTP?.LTP}
                      </td>
                      <td id={`unitID_${obj.id}`}>{obj.buy_price}</td>
                      <td id={`qtyID_${obj.id}`}>{obj.unit_qty}</td>
                      <td id={`buyAmountID_${obj.id}`}>
                        {(
                          parseFloat(obj.buy_price) * parseFloat(obj.unit_qty)
                        ).toFixed(2)}
                      </td>
                      <td id={`slID_${obj.id}`}>{obj.sl_price}</td>
                      <td id={`gttID_${obj.id}`}>{obj.gtt_price}</td>

                      <td
                        style={{
                          textAlign: "right",
                          color:
                            parseFloat(todayLTP?.LTP) >
                            parseFloat(obj.buy_price)
                              ? "#1c8b16"
                              : "#f00",
                        }}
                      >
                        {parseFloat(todayLTP?.LTP)
                          ? (
                              ((parseFloat(todayLTP?.LTP) -
                                parseFloat(obj.buy_price)) *
                                100) /
                              parseFloat(obj.buy_price)
                            ).toFixed(2)
                          : ""}
                        %
                      </td>
                      <td>
                        {/* {degAngle(prediction?.price_5, todayLTP?.LTP, 5)} */}
                        {degAngle(
                          obj.buy_price,
                          todayLTP?.LTP,
                          diffDays(obj.buy_date, new Date())
                        )}
                      </td>
                      <td
                        style={{ textAlign: "right" }}
                        title={`${prediction?.price_14} | ${moment(
                          prediction?.price_14_date
                        ).format("DD/MM/YYYY")}`}
                      >
                        {prediction?.price_14_date_PL}%
                      </td>

                      <td
                        style={{
                          textAlign: "right",
                          background:
                            parseFloat(prediction?.sma50) >
                            parseFloat(prediction?.sma200)
                              ? "#e2ffe5"
                              : "#fff8f8",
                        }}
                        title={`DMA50: ${prediction?.sma50}`}
                      >
                        {prediction?.sma200}
                      </td>
                      <td>{obj.strengthCount}</td>
                      <td style={{ textAlign: "right" }}>{obj.deliveryPer}%</td>
                      {/* <td
                        style={{
                          textAlign: "right",
                          color:
                            parseFloat(prediction?.delivery_per) >
                            parseFloat(obj.deliveryPer)
                              ? "#1c8b16"
                              : "#f00",
                        }}
                      >
                        {prediction?.delivery_per}%
                      </td> */}
                      {/* <td style={{ textAlign: "left" }}>{details?.events}</td> */}
                      <td style={{ textAlign: "left" }}>
                        {obj.buyerName === "Pratima" ? "P" : "S"} |{" "}
                        {obj.dematName}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          className="addPortfolio"
                          onClick={(e) => addPortfolioHandler(e, obj)}
                        ></button>

                        <a
                                                        title="News"
                                                        className="newsicon"
                                                        href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      ></a>
                      </td>
                    </tr>
                  );
                })}

                <tr>
                  <td
                    colSpan={14}
                    className="fw-bold"
                    style={{ textAlign: "right", backgroundColor: "#fafafa" }}
                  >
                    Total
                  </td>
                  <td
                    className="fw-bold"
                    style={{ textAlign: "right", backgroundColor: "#fafafa" }}
                  >
                    {totalInvest}
                  </td>
                  <td
                    colSpan={10}
                    className="fw-bold"
                    style={{ backgroundColor: "#fafafa" }}
                  ></td>
                </tr>
              </tbody>
            </table>

            <table className="increaseOI table-responsive mt-5">
              <thead>
                <tr>
                  <th style={{ width: "20px", textAlign: "left"}}>SN.</th>
                  <th style={{ width: "98px", textAlign: "left"}}>Sold Date</th>
                  <th style={{ width: "98px", textAlign: "left"}}>Buy Date</th>
                  <th style={{ width: "35px" }}>Days</th>
                  <th style={{ width: "120px", textAlign: "left"}}>Symbol</th>
                  <th style={{ width: "150px", textAlign: "left"}}>Sector</th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "45px" }}></th>
                  <th style={{ width: "45px", textAlign: "left" }}>Strength</th>
                  <th style={{ width: "75px" }}>LTP</th>
                  <th style={{ width: "75px" }}>Buy Unit</th>
                  <th style={{ width: "75px" }}>Sell Unit</th>
                  <th style={{ width: "50px" }}>Units</th>
                  <th style={{ width: "100px" }}>Buying Price</th>
                  <th style={{ width: "100px" }}>Selling Price</th>
                  <th style={{ width: "90px" }}>P/L</th>
                  <th style={{ width: "65px" }}>%</th>
                  <th style={{ width: "70px" }}>SMA200</th>
                  <th style={{ width: "50px" }}>W Stgh</th>
                  <th style={{ width: "55px", textAlign: "left"}}>Indices</th>
                  <th style={{ width: "100px", textAlign: "left"}}>Method</th>
                  <th style={{ width: "90px", textAlign: "left"}}></th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(mySoldListData)?.map((obj, index) => {
                  const monthName = obj[0];
                  const monthData = obj[1];

                  let monthTotalBuy = 0;
                  let monthTotalSold = 0;
                  let monthTotalPL = 0;
                  let monthTotalPLPer = 0;
                  let monthTotalLoos = 0;

                  return (
                    <>
                      <tr key={`row_month_${index}`}>
                        <td
                          colSpan={22}
                          className="fw-bold"
                          style={{ backgroundColor: "#fafafa" }}
                        >
                          {monthName}
                        </td>
                      </tr>

                      {monthData?.map((item, ind) => {
                        const symbolName = item.symbol;
                        let details = symbolData.find(
                          (item, index) => item.symbol === symbolName
                        );
                        let todayLTP = todayData.find(
                          (item, index) => item.TICKER === symbolName
                        );
                        let prediction = predictionData?.find(
                          (item) => item.symbol === symbolName
                        );

                        let PL = (
                          item.sold_price * item.unit_qty -
                          item.buy_price * item.unit_qty
                        ).toFixed(2);
                        let per = (
                          (PL * 100) /
                          (item.buy_price * item.unit_qty)
                        ).toFixed(2);

                        monthTotalBuy = (
                          parseFloat(monthTotalBuy) +
                          parseFloat(item.buy_price * item.unit_qty)
                        ).toFixed(2);
                        monthTotalSold = (
                          parseFloat(monthTotalSold) +
                          parseFloat(item.sold_price * item.unit_qty)
                        ).toFixed(2);
                        monthTotalPL = (
                          parseFloat(monthTotalPL) + parseFloat(PL)
                        ).toFixed(2);
                        monthTotalPLPer = (
                          (monthTotalPL * 100) /
                          monthTotalBuy
                        ).toFixed(2);

                        if (parseFloat(PL) < 0) {
                          monthTotalLoos = (
                            parseFloat(monthTotalLoos) + parseFloat(PL)
                          ).toFixed(2);
                        }

                        return (
                          <tr
                            key={`item_row_id_${item.id}`}
                            id={`item_row_id_${index}_${ind}`}
                          >
                            <td>{ind + 1}</td>
                            <td style={{ textAlign: "left",fontSize: '0.675rem'  }} title={item.sold_tara}>
                              {moment(item.sold_date).format("ddd | DD/MM/YY")}
                            </td>
                            <td style={{ textAlign: "left",fontSize: '0.675rem'  }} title={item.buy_tara}>
                              {moment(item.buy_date).format("ddd | DD/MM/YY")}
                            </td>
                            <td>{diffDays(item.buy_date, item.sold_date)}</td>
                            <td
                              style={{ textAlign: "left" }}
                              className="symbolName"
                            >
                              {symbolName}{" "}
                              {details?.hotStar === "1" ? (
                                <span className="hotStar"></span>
                              ) : null}
                            </td>
                            <td style={{ textAlign: "left", lineHeight:1.15, textWrap:'wrap' }}>{details?.sector}</td>
                            <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={todayLTP?.LTP}
                                deliveryPer={prediction?.delivery_per}
                                hotStar={details?.hotStar}
                                myFev={details?.myFev}
                                eventName="Delivery"
                                rowId={`item_row_id_${index}_${ind}`}
                              />
                            </td>
                            <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={moment(startDate).format("YYYY-MM-DD")}
                              />
                            </td>
                            <StockStrength
                              id={`pl_${index}`}
                              selectedDate={moment(startDate).format("YYYY-MM-DD")}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={details}
                              predictions={prediction}
                            />
                            <td
                              title={
                                todayLTP?.DATETIME !== "#N/A" &&
                                todayLTP?.DATETIME
                                  ? moment(todayLTP?.DATETIME).format(
                                      "DD/MM/YY HH:mm"
                                    )
                                  : null
                              }
                              style={{
                                color:
                                  todayLTP?.LTP > item.sold_price
                                    ? "#1c8b16"
                                    : "#f00",
                              }}
                            >
                              {todayLTP?.LTP}
                            </td>
                            <td>{item.buy_price}</td>
                            <td>{item.sold_price}</td>
                            <td>{item.unit_qty}</td>
                            <td>
                              {(item.unit_qty * item.buy_price)?.toFixed(2)}
                            </td>
                            <td>
                              {(item.unit_qty * item.sold_price)?.toFixed(2)}
                            </td>
                            <td style={{ color: PL > 0 ? "" : "#f00" }}>
                              {PL}
                            </td>
                            <td>{`${per}%`}</td>
                            <td
                              style={{
                                textAlign: "right",
                                background:
                                  parseFloat(prediction?.sma50) >
                                  parseFloat(prediction?.sma200)
                                    ? "#e2ffe5"
                                    : "#fff8f8",
                              }}
                              title={`DMA50: ${prediction?.sma50}`}
                            >
                              {prediction?.sma200}
                            </td>
                            <td>{item.strengthCount}</td>
                            <td
                              className="indices"
                              style={{ textAlign: "left" }}
                            >
                              {(() => {
                                const label = details?.nifty50
                                  ? "50"
                                  : details?.nifty100
                                  ? "100"
                                  : details?.nifty200
                                  ? "200"
                                  : details?.nifty500
                                  ? "500"
                                  : details?.totalMarket
                                  ? "TM"
                                  : "";
                                const excludedSeries = ["ETF", "BOND", "MF"];
                                const showFev =
                                  details?.myFev &&
                                  !excludedSeries.includes(details?.series);
                                return (
                                  label +
                                  (showFev ? `${label ? ", " : ""}Fev` : "")
                                );
                              })()}
                            </td>
                            <td style={{ textAlign: "left" }}>{item.method}</td>
                            <td style={{ textAlign: "left" }}>
                              {item.buyerName === "Pratima" ? "P" : "S"} |{" "}
                              {item.dematName}
                            </td>
                          </tr>
                        );
                      })}

                      <tr
                        key={`row_month_total_${index}`}
                        id={`row_month_total_${index}`}
                      >
                        <td
                          colSpan={13}
                          className="fw-bold"
                          style={{
                            textAlign: "right",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          Total
                        </td>
                        <td
                          className="fw-bold"
                          style={{
                            textAlign: "right",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          {parseFloat(monthTotalBuy).toLocaleString("en-IN")}
                        </td>
                        <td
                          className="fw-bold"
                          style={{
                            textAlign: "right",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          {parseFloat(monthTotalSold).toLocaleString("en-IN")}
                        </td>
                        <td
                          className="fw-bold"
                          style={{ backgroundColor: "#fafafa" }}
                        >
                          {parseFloat(monthTotalPL).toLocaleString("en-IN")}
                        </td>
                        <td
                          className="fw-bold"
                          style={{ backgroundColor: "#fafafa", color: "#F00" }}
                        >
                          {parseFloat(monthTotalLoos).toLocaleString("en-IN")}
                        </td>
                        <td
                          className="fw-bold"
                          style={{ backgroundColor: "#fafafa" }}
                        >
                          {monthTotalPLPer}%
                        </td>
                        <td
                          colSpan={5}
                          className="fw-bold"
                          style={{ backgroundColor: "#fafafa" }}
                        ></td>
                      </tr>
                    </>
                  );
                })}
                <tr>
                  <td
                    colSpan={11}
                    className="fw-bold"
                    style={{ textAlign: "left", backgroundColor: "#fafafa" }}
                    title="Demate Amount"
                  >
                    {parseFloat(totalInDematAmount).toLocaleString("en-IN")}
                    <span style={{ color: "#1c8b16" }}>
                      &nbsp;&nbsp; [
                      {(
                        (parseFloat(getYearlyStatus?.yearlyTotalPL) * 100) /
                        parseFloat(totalInDematAmount)
                      ).toFixed(2)}
                      %]
                    </span>
                  </td>
                  <td
                    colSpan={2}
                    className="fw-bold"
                    style={{ textAlign: "right", backgroundColor: "#fafafa" }}
                  >
                    Yearly Total
                  </td>
                  <td
                    className="fw-bold"
                    style={{ textAlign: "right", backgroundColor: "#fafafa" }}
                  >
                    {parseFloat(getYearlyStatus?.yearlyTotalBuy).toLocaleString(
                      "en-IN"
                    )}
                  </td>
                  <td
                    className="fw-bold"
                    style={{ textAlign: "right", backgroundColor: "#fafafa" }}
                  >
                    {parseFloat(
                      getYearlyStatus?.yearlyTotalSold
                    ).toLocaleString("en-IN")}
                  </td>
                  <td
                    className="fw-bold"
                    style={{ backgroundColor: "#fafafa" }}
                  >
                    {parseFloat(getYearlyStatus?.yearlyTotalPL).toLocaleString(
                      "en-IN"
                    )}
                  </td>
                  <td
                    className="fw-bold"
                    style={{ backgroundColor: "#fafafa", color: "#F00" }}
                  >
                    {getYearlyStatus?.yearlyTotalLoss}
                  </td>
                  <td
                    className="fw-bold"
                    style={{ backgroundColor: "#fafafa" }}
                  >
                    {getYearlyStatus?.yearlyTotalPLPer}%
                  </td>
                  <td
                    colSpan={5}
                    className="fw-bold"
                    style={{ backgroundColor: "#fafafa" }}
                  ></td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        // fullscreen = {true}
        dialogClassName="watchlist-details"
        // backdrop="static"
        // keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <div className="col-5 ps-3 pt-2" style={{display: "flex", justifyContent: "space-between", width: "100%"}}><span>{paramsMeta.symbol} <small>[{paramsMeta.method}]</small></span>  <span className="pe-5">{getTara}</span></div>
          <div className="col-6 pt-2 text-danger small">
            {toastShown
              ? "Amount should be greater than unit price (" +
                paramsMeta.buy_price +
                ")"
              : ""}
          </div>
          <div className="col-1">
                  <div className="modalStockAcion" style={{right:'10px', top:'15px'}}>
                              <StockAction
                                symbol={paramsMeta.symbol}
                                delivery={false}
                              />
                  </div>
          </div>

        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => postPortfolioData(e)}>
            <div className="row p-3">
              <div className="col pe-0">
                <div className="form-floating">
                  <DatePicker
                    name="soldDate"
                    placeholderText={getDateLabel}
                    className="form-control"
                    selected={startDate}
                    onChange={(date) => handleDateChange(date)}
                    dateFormat="dd/MM/YYYY"
                    // minDate={moment().subtract(7, "days")}
                    maxDate={new Date()}
                  />
                  <label className="show" htmlFor="soldDate">
                    {getDateLabel}
                  </label>
                </div>
              </div>
              
              <div className="col pe-0">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="buyingprice"
                    id="buyingprice"
                    placeholder="Buying Price"
                    defaultValue={paramsMeta.buy_price}
                    // onKeyPress={(event) => { if (!/^\d*\.?\d*$/.test(event.key)) { event.preventDefault(); } }}
                    onBlur={(e) => unitPriceUpdateHindler(e)}
                    onKeyPress={(event) => {
                      const char = event.key;
                      const currentValue = event.currentTarget.value;

                      if (!/[\d.]/.test(char)) {
                        event.preventDefault();
                      }

                      if (char === ".") {
                        if (currentValue.includes(".") || currentValue === "") {
                          event.preventDefault();
                        }
                      }
                    }}
                  />
                  <label htmlFor="buyingprice">Unit Price</label>
                </div>
              </div>
              <div className="col pe-0">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="slPriceU"
                    id="slPriceU"
                    placeholder="SL Price"
                    defaultValue={slPriceU}
                    onKeyUp={(e) => slUnitPriceChangeHandler(e)}
                    onKeyPress={(event) => {
                      const char = event.key;
                      const currentValue = event.currentTarget.value;

                      if (!/[\d.]/.test(char)) {
                        event.preventDefault();
                      }

                      if (char === ".") {
                        if (currentValue.includes(".") || currentValue === "") {
                          event.preventDefault();
                        }
                      }
                    }}
                  />
                  <label htmlFor="slPriceU">SL Price</label>
                </div>
              </div>
              <div className="col pe-0">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="gttpriceU"
                    id="gttpriceU"
                    placeholder="GTT Price"
                    defaultValue={gttPriceU}
                    onKeyUp={(e) => gttUnitPriceChangeHandler(e)}
                    onKeyPress={(event) => {
                      const char = event.key;
                      const currentValue = event.currentTarget.value;

                      if (!/[\d.]/.test(char)) {
                        event.preventDefault();
                      }

                      if (char === ".") {
                        if (currentValue.includes(".") || currentValue === "") {
                          event.preventDefault();
                        }
                      }
                    }}
                  />
                  <label htmlFor="gttpriceU">GTT Price</label>
                </div>
              </div>

              <div className="col pe-0">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="soldprice"
                    id="soldprice"
                    placeholder="Sold Price"
                    defaultValue={paramsMeta.sold_price}
                    // onKeyPress={(event) => { if (!/^\d*\.?\d*$/.test(event.key)) { event.preventDefault(); } }}
                    onKeyPress={(event) => {
                      const char = event.key;
                      const currentValue = event.currentTarget.value;

                      if (!/[\d.]/.test(char)) {
                        event.preventDefault();
                      }

                      if (char === ".") {
                        if (currentValue.includes(".") || currentValue === "") {
                          event.preventDefault();
                        }
                      }
                    }}
                  />
                  <label htmlFor="soldprice">Sold Price</label>
                </div>
              </div>

              <div className="col">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="soldqty"
                    id="soldqty"
                    placeholder="Sold Qty"
                    defaultValue={paramsMeta.unit_qty}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="soldqty">Sold Qty</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="ps-4 col-4 pb-3">
                <div className="d-flex small">
                  <span style={{width:'40px'}}>SL: </span>
                  <div className="me-3">{getUnitPrice}</div>&nbsp; X
                  <input
                    className="ms-1 gttprice"
                    style={{ width: "50px", textAlign: "right" }}
                    type="text"
                    id="slpercent"
                    defaultValue={slPercent}
                    onKeyUp={(e) => slpercentChangeHandler(e)}
                  />
                  % &nbsp;&nbsp;&nbsp;=&nbsp;&nbsp;
                  <input
                    className="ms-1 gttprice"
                    style={{ width: "100px" }}
                    type="text"
                    id="slunitprice"
                    defaultValue={slPriceU}
                    onKeyUp={(e) => slUnitPriceChangeHandler(e)}
                    onKeyPress={(event) => {
                      const char = event.key;
                      const currentValue = event.currentTarget.value;

                      if (!/[\d.]/.test(char)) {
                        event.preventDefault();
                      }

                      if (char === ".") {
                        if (currentValue.includes(".") || currentValue === "") {
                          event.preventDefault();
                        }
                      }
                    }}
                  />
                </div>
                <div className="d-flex small">
                  <span style={{width:'40px'}}>GTT: </span>
                  <div className="me-3">{getUnitPrice}</div>&nbsp; X
                  <input
                    className="ms-1 gttprice"
                    style={{ width: "50px", textAlign: "right" }}
                    type="text"
                    id="gttpercent"
                    defaultValue={gttPercent}
                    onKeyUp={(e) => gttpercentChangeHandler(e)}
                  />
                  % &nbsp;&nbsp;&nbsp;=&nbsp;&nbsp;
                  <input
                    className="ms-1 gttprice"
                    style={{ width: "100px" }}
                    type="text"
                    id="gttunitprice"
                    defaultValue={gttPriceU}
                    onKeyUp={(e) => gttUnitPriceChangeHandler(e)}
                    onKeyPress={(event) => {
                      const char = event.key;
                      const currentValue = event.currentTarget.value;

                      if (!/[\d.]/.test(char)) {
                        event.preventDefault();
                      }

                      if (char === ".") {
                        if (currentValue.includes(".") || currentValue === "") {
                          event.preventDefault();
                        }
                      }
                    }}
                  />
                </div>
              </div>

              <div className="pb-3 pe-4 col-3 pt-2">
                <div className="d-flex justify-content-end">{parseInt(paramsMeta.gtt_SL) === 1}
                    <div className="form-check me-4 mt-1">
                      <input
                        onChange={(e) => gttUpdateHandler(e)}
                        className="form-check-input"
                        type="checkbox"
                        defaultChecked={ parseInt(paramsMeta.gtt_SL) === 1}
                        id="forgttactiveSL"
                      />
                      <label htmlFor="forgttactiveSL">
                        Active SL
                      </label>
                    </div>

                    <div className="form-check mt-1">
                      <input
                        onChange={(e) => gttUpdateHandler(e)}
                        className="form-check-input"
                        type="checkbox"
                        defaultChecked={ parseInt(paramsMeta.gtt_Target) === 1}
                        id="forgttactiveTarget"
                      />
                      <label htmlFor="forgttactiveTarget">
                        Active Target
                      </label>
                    </div>
                  </div>
              </div>

              <div className="pb-3 pe-4 col-5 pt-2">
                <div className="d-flex justify-content-end">
                  <div className="form-check me-4 mt-1">
                    <input
                      onChange={(e) => gttUpdateHandler(e)}
                      className="form-check-input"
                      type="checkbox"
                      id="forgttupdate"
                    />
                    <label htmlFor="forgttupdate">
                      GTT
                    </label>
                  </div>

                  <div className="form-check  me-4 mt-1">
                    <input
                      onChange={(e) => allUpdateHandler(e)}
                      className="form-check-input"
                      type="checkbox"
                      id="forAllUpdate"
                    />
                    <label htmlFor="forAllUpdate">
                      PRICE/UNIT
                    </label>
                  </div>
                  {/* <button type="submit" id="updateBtn" className="btn btn-outline-secondary px-4 me-3">Update</button>  */}
                  <button
                    type="submit"
                    id="submitBtn"
                    className="btn btn-primary px-4"
                  >
                    Sold
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default PortfolioListPage;